@if (active) {
  <section class="notifications-container">
    <header class="header">
      <button class="close-btn" mat-icon-button (click)="closeNotificationCenter.next(true)">
        <mat-icon class="close-btn-icon">chevron_right</mat-icon>
      </button>
      <span class="title">{{ 'avian.notification.title' | translate }}</span>
      <mat-icon class="notification-icon">notifications</mat-icon>
    </header>
    @if (notifications?.length > 0) {
      <section class="notifications">
        @for (n of notifications; track n) {
          <article class="notification" [class.remove-fade-out]="n.remove" (mouseenter)="onNotificationHover(n, true)" (mouseleave)="onNotificationHover(n, false)">
            <span class="notification-status" [class.unread-flag]="!n.read">&nbsp;</span>
            <div class="message-details" (click)="openAppStore(n)">
              <span class="message-text" [innerHTML]="n.messageKey | translate: n.templateParams | mobileUrlReplacer"></span>
              <span class="message-date">
                {{ createdDate(n) | amTimeAgo }}
              </span>
            </div>
            @if (!n.mobileOnly) {
              <button class="delete" mat-icon-button (click)="removeNotification(n)">
                @if (n.highlighted) {
                  <mat-icon>delete</mat-icon>
                }
              </button>
            }
          </article>
        }
      </section>
    } @else {
      <app-empty-grid-container></app-empty-grid-container>
    }
    @if (notifications.length) {
      <footer class="floating-footer-actions">
        <button data-role="delete" mat-button (click)="deleteAll()">
          <mat-icon>delete_sweep</mat-icon>
          <span>{{ 'avian.notification.delete_all' | translate }}</span>
        </button>
      </footer>
    }
  </section>
}
